import { render, staticRenderFns } from "./UploadedItemRow.vue?vue&type=template&id=65f69a12&scoped=true"
import script from "./UploadedItemRow.vue?vue&type=script&lang=js"
export * from "./UploadedItemRow.vue?vue&type=script&lang=js"
import style0 from "./UploadedItemRow.vue?vue&type=style&index=0&id=65f69a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f69a12",
  null
  
)

export default component.exports